const React = require('react');
const Swipe = require('../../Swipe');
const Person = require('../../Person');
const _ = require('../../../../lib/underscore');
const isNode = (typeof process !== 'undefined');
const Map = isNode ? require('../../Map') : () => <div/>;
const PropertyPrice = require('../../PropertyComponents/PropertyPrice');
const PropertySize = require('../../PropertyComponents/PropertySize');
const PropertyType = require('../../PropertyComponents/PropertyType');

const ensureArray = function(obj) {
    const values = (obj && obj['finn:value']) ? obj['finn:value'] : null;
    const fields = (values && values['finn:field']) ? values['finn:field'] : null;
    if (!fields) return null;
    return Array.isArray(fields) ? fields : [fields];
};

class RentalShow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: 0
        };

        this.slideNext = this.slideNext.bind(this);
        this.slidePrev = this.slidePrev.bind(this);
    }

    componentDidMount() {
        this.refs.swipe.swiper.on('slideChangeEnd', () => {
            this.setState({selected: this.refs.swipe.swiper.activeIndex});
        });
    }

    componentWillUnmount() {
        this.refs.swipe.swiper.off('slideChangeEnd');
    }

    slideNext() {
        this.refs.swipe.swiper.slideNext();
    }

    slidePrev() {
        this.refs.swipe.swiper.slidePrev();
    }

    render() {
        const props = this.props;
        const {selected} = this.state;
        const fields = props.adata['finn:adata']['finn:field'];

        // Data fields
        const excerpt = _.filter(fields, field => field._attributes.name === "ingress").shift()
        const generalText = _.filter(fields, field => field._attributes.name === "general_text").shift()
        if (generalText) {
            // generalText.title = _.where(generalText['finn:value']['finn:field'], {name: 'title' }).shift()['value'];
            generalText.title = _.filter(generalText['finn:value']['finn:field'], field => field._attributes.name === "title").shift()['_attributes']['value'];
            // generalText.content = _.where(generalText['finn:value']['finn:field'], {name: 'value' }).shift()['$t'];
            generalText.content = _.filter(generalText['finn:value']['finn:field'], field => field._attributes.name === "value").shift()['_text']
        }

        const facilities = _.filter(fields, field => field._attributes.name === "facilities").shift();
        const floor = _.filter(fields, field => field._attributes.name === "floor").shift();
        const energyLabel = _.filter(fields, field => field._attributes.name === "energy_label").shift();
        const timespan = _.filter(fields, field => field._attributes.name === "timespan").shift();
        const numBedrooms = _.filter(fields, field => field._attributes.name === "no_of_bedrooms").shift();
        const parkingSpots = _.filter(fields, field => field._attributes.name === "parking_spots").shift();
        const constructionYear = _.filter(fields, field => field._attributes.name === "construction_year").shift();
        const acquisition = _.filter(fields, field => field._attributes.name === "acquisition").shift();
        const propertyType = _.filter(fields, field => field._attributes.name === "property_type").shift();
        const price = props.adata['finn:adata']['finn:price'] || null;
        const size =  _.filter(fields, field => field._attributes.name === "size").shift();
        const access =  _.filter(fields, field => field._attributes.name === "access").shift();
        const situation =  _.filter(fields, field => field._attributes.name === "situation").shift();
        const condition =  _.filter(fields, field => field._attributes.name === "condition").shift();
        const cadastres =  _.filter(fields, field => field._attributes.name === "cadastres").shift() || null;
        const cadastreValues = ensureArray(cadastres);
        const countyNumber = cadastreValues ? _.filter(fields, field => field._attributes.name === "county_number").shift() : null;
        const cadastralUnitNumber = cadastreValues ? _.filter(fields, field => field._attributes.name === "cadastral_unit_number").shift() : null;
        const propertyUnitNumber = cadastreValues ? _.filter(fields, field => field._attributes.name === "property_unit_number").shift() : null;
        const content =  _.filter(fields, field => field._attributes.name === "content").shift()
        const location = props.location.split(' ');
        const contactObj = Array.isArray(props.adata['finn:contact'])
                           ? props.adata['finn:contact']
                           : [props.adata['finn:contact']];

        const contactPersons = contactObj.map(co => ({
            displayName: co['name']._text,
            data: {
                image: props.personImage,
                title: (co['_attributes'] && co['_attributes'].title) ? co['_attributes'].title : null,
                email: (co['email'] && co['email']._text) ? co['email']._text : null,
                phone: (co['finn:phone-number'] && co['finn:phone-number']._text) ? co['finn:phone-number']._text : null
            }
        }));
        const disposedArr = props.adata.category.filter(a => a._attributes.scheme === 'urn:finn:ad:disposed');
        let disposed = false;
        if (disposedArr.length) {
            disposed = disposedArr.shift()['_attributes']['term'] === 'true' || false;
        }

        const arrowIcon = <svg x="0px" y="0px" viewBox="0 0 46.4 45.5">
            <path fill="#535868" d="M13,2.5c-1.1,1.1-1.1,3,0,4.1l16.3,16.2l-16,16c-1.2,1.1-1.2,2.9-0.1,4.1s2.9,1.2,4.1,0.1 c0,0,0.1-0.1,0.1-0.1l18-18c1.1-1.1,1.1-3,0-4.1L17.1,2.5C16,1.4,14.1,1.4,13,2.5z"/>
        </svg>;

        return (
        <section className="rental">
            <div className="rental__container">
                {/*TODO: Component'ize this*/}

                {/* Title and statusbar */}
                <div className="rental__title-bar">
                    {props.address} &ndash; {props.postalCode} {' ' + props.city}
                    {disposed && (
                        <span className="rental__disposed">Utleid</span>
                    )}
                </div>

                {/* Slideshow */}
                <div className="rental__slideshow-container">
                    <Swipe ref="swipe" options={{loop: false, centeredSlides: true, slidesPerView: 'auto' }} pagination={false}>
                        {props.images.map(image => {
                            return (
                            <div className="rental__slide" onClick={this.slideNext}>
                                <img src={image} draggable={false}/>
                            </div>
                            )
                        })}
                    </Swipe>
                    <div className="rental__slideshow-controls">
                        <a className="rental__slideshow-control-btn rental__prev-btn" onClick={this.slidePrev}>
                            {arrowIcon}
                        </a>
                        <span className="rental__slideshow-progress">
                        {selected + 1}/{props.images.length}
                    </span>
                        <a className="rental__slideshow-control-btn rental__next-btn" onClick={this.slideNext}>
                            {arrowIcon}
                        </a>
                    </div>
                </div>


                {/* Content */}

                <div className="rental__columns">
                    <div className="rental__left-column">

                        <div className="rental__facts">
                            {floor && (
                                <div className="rental__fact">
                                    <span className="rental__fact-header">Etasje</span>
                                    <div className="rental__fact-value">{floor._attributes.value}</div>
                                </div>
                            )}

                            {numBedrooms && (
                                <div className="rental__fact">
                                    <span className="rental__fact-header">Soverom</span>
                                    <div className="rental__fact-value">{numBedrooms._attributes.value}</div>
                                </div>
                            )}

                            {parkingSpots && (
                                <div className="rental__fact">
                                    <span className="rental__fact-header">Ant p-plasser</span>
                                    <div className="rental__fact-value">{parkingSpots._attributes.value}</div>
                                </div>
                            )}
                            {constructionYear && (
                                <div className="rental__fact">
                                    <span className="rental__fact-header">Byggeår</span>
                                    <div className="rental__fact-value">{constructionYear._attributes.value}</div>
                                </div>
                            )}

                            {acquisition && (
                                <div className="rental__fact">
                                    <span className="rental__fact-header">Overtagelse</span>
                                    <div className="rental__fact-value">{acquisition._attributes.value}</div>
                                </div>
                            )}

                            {price && <PropertyPrice price={price} />}
                            {size && <PropertySize size={size['finn:field']} />}
                            {propertyType && <PropertyType type={propertyType['finn:value']} />}

                            {energyLabel && (
                                <div className="rental__fact">
                                    <span className="rental__fact-header">Energimerking</span>
                                    <div className="rental__fact-value">{energyLabel._attributes.value}</div>
                                </div>
                            )}

                            {timespan && (
                                <div className="rental__fact">
                                    <span className="rental__fact-header">Leieperiode</span>
                                    <div className="rental__fact-value">{timespan._attributes.from}</div>
                                </div>
                            )}

                        </div>

                        {facilities && (
                            <div className="rental__facilities">
                                <h3>Fasiliteter</h3>
                                <ul className="rental__facts-list">
                                    {Array.isArray(facilities['finn:value']) ? (
                                        facilities['finn:value'].map(facility => {
                                            return <li>{facility._text}</li>
                                        })
                                    ) : (
                                         [facilities['finn:value']].map(facility => {
                                             return <li>{facility._text}</li>
                                         })
                                     )}
                                </ul>
                            </div>
                        )}


                        <h2 className="rental__title">{props.title}</h2>

                        {excerpt && <div className="rental__excerpt" dangerouslySetInnerHTML={{__html: excerpt._text}}></div>}

                        <div className="rental__body">
                            {generalText && (
                            <div className="rental__body-section">
                                <h3>{generalText.title}</h3>
                                <div dangerouslySetInnerHTML={{__html: generalText.content}}></div>
                            </div>
                            )}

                            {access && (
                            <div className="rental__body-section">
                                <h3>Adkomst</h3>
                                <div dangerouslySetInnerHTML={{__html: access._text}}></div>
                            </div>
                            )}

                            {situation && (
                            <div className="rental__body-section">
                                <h3>Beliggenhet</h3>
                                <div dangerouslySetInnerHTML={{__html: situation._text}}></div>
                            </div>
                            )}

                            {condition && (
                            <div className="rental__body-section">
                                <h3>Standard</h3>
                                <div dangerouslySetInnerHTML={{__html: condition._text}}></div>
                            </div>
                            )}

                            {content && (
                            <div className="rental__body-section">
                                <h3>Innhold</h3>
                                <div dangerouslySetInnerHTML={{__html: content._text}}></div>
                            </div>
                            )}

                            {cadastreValues && (
                            <div className="rental__body-section">
                                <h3>Matrikkelinformasjon</h3>
                                <div>
                                    {countyNumber && <p><span><strong>Kommunenummer:</strong> {countyNumber['value']._text}</span></p>}
                                    {cadastralUnitNumber && <p><span><strong>Gårdsnr.:</strong> {cadastralUnitNumber['value']._text}</span></p>}
                                    {propertyUnitNumber && <p><span><strong>Bruksnr.:</strong> {propertyUnitNumber['value']._text}</span></p>}
                                </div>
                            </div>
                            )}

                            <div className="rental__body-section">
                                <h3>&nbsp;</h3>
                                <div>
                                    <p>
                                        Se annonsen på <a href={`http://finn.no/${props.finnId}`}>Finn.no</a>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="rental__right-column">
                        {contactPersons.map(contactPerson => <Person person={contactPerson} />)}
                        {location && <Map position={{latitude: location[0], longitude: location[1]}} address={props.address} zip={props.postalCode} city={props.city} />}
                    </div>
                </div>
            </div>
        </section>
        )
    }
}

module.exports = RentalShow;



// WEBPACK FOOTER //
// ./src/main/resources/site/parts/rental-show/Component/index.jsx